import React, { useEffect, useState } from "react";
import Layout from "../Componants/Layout";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getRequest, postRequest } from "../services/apiMethods";
import { getQueryParams, useDecrypt, useEncrypt } from "../utils/HelperFunctions";
import { useLoginContext } from "../context/LoginContext";

export default function YourSubscription() {
  const Navigate = useNavigate();
  const Location = useLocation()
  const queryParams = getQueryParams(Location?.search);
  const { leadId } = queryParams;

  console.log(leadId, "leadIdleadIdleadIdleadIdleadId")
  const { userData, refresh } = useLoginContext();
  const [catalog, setCatalog] = useState()
  const [loading, setLoading] = useState(false)
  const { mutate: subscriptionCatalog } = useMutation({
    mutationFn: (data) => {
      setLoading(true)
      return getRequest("/lead/subscription/catalog", data);
    },
    onSuccess: (data) => {
      if (data?.statusCode === 200) {
        setCatalog(data?.data.reverse())
        setLoading(false)
      }

    },
    onError: (error) => {
      console.error("Error during API call:", error);
      setLoading(false)
    },
  });



  useEffect(() => {
    subscriptionCatalog()
  }, [])



  console.log(loading, "loadingloadingloadingloading534534")

  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: (data) => {
      return postRequest("/lead/subscription", data);
    },
    onSuccess: (data) => {
      if (data?.statusCode === 200) {
        window.location.href = `${data?.data?.url}`;
      }
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });

  // const encryptedEmail = useEncrypt("example@example.com");
  // console.log("Encrypted Email:", encryptedEmail);

  // const decryptedEmail = useDecrypt(encryptedEmail);
  // console.log("Decrypted Email:", decryptedEmail);


  const handleSubscription = (id) => {
    const payload = {
      priceId: id,
      leadId: leadId
    };
    mutate(payload);
  };

  const { mutate:CancelSubScription, } = useMutation({
    mutationFn: () => {
      return postRequest("/lead/subscription/cancel");
    },
    onSuccess: (data) => {
        if (data?.statusCode === 200) {
          window.location.href = `${data?.data?.url}`;
        }
  
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });

  return (
    <>
      <Layout>
        <Container>
          <div className="dashboard-main">
            <h3
              className="with-back-btn cursor-pointer"
              onClick={() => Navigate(-1)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M4 12L3.29289 11.2929L2.58579 12L3.29289 12.7071L4 12ZM19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11V13ZM9.29289 5.29289L3.29289 11.2929L4.70711 12.7071L10.7071 6.70711L9.29289 5.29289ZM3.29289 12.7071L9.29289 18.7071L10.7071 17.2929L4.70711 11.2929L3.29289 12.7071ZM4 13H19V11H4V13Z"
                  fill="black"
                />
              </svg>
              Account
            </h3>
            <Row>
              <Col lg={12}>
                <div className="my-profile-title">
                  <h4>Your Subscription</h4>
                  <p>You can update your subscription at any time.</p>
                </div>
              </Col>
              {loading ?
                <>
                  <Col lg={6} >
                    <div className="my-profile-card-contain">
                      <div className="my-profile-box-contain">
                        <div className="pre-pending-card" style={{ height: 400 }}>
                          <div style={{ display: "flex", justifyContent: "center", marginTop: 50 }} >
                            <Spinner animation="border" variant="primary" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col lg={6} >
                    <div className="my-profile-card-contain">
                      <div className="my-profile-box-contain">
                        <div className="pre-pending-card" style={{ height: 400 }}>
                          <div style={{ display: "flex", justifyContent: "center", marginTop: 50 }}>
                            <Spinner animation="border" variant="primary" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>

                </>
                :
                <>
                  {Array.isArray(catalog) && catalog.length > 0 ? (
                    <>
                      {catalog.map((ele, index) => (
                        <Col lg={6} key={index}
                        >
                          <div className="my-profile-card-contain  ">
                            <div className="my-profile-box-contain  ">
                              <div className={`${userData?.activePlan?.name === ele?.name ? "pre-pending-card activePlan " : "pre-pending-card"}`}>
                                <div className="pre-pending-pro">
                                  <div className="pending-pro-view">
                                    <div>
                                      <h3>
                                        {ele?.name}
                                        {userData?.activePlan?.name === ele?.name ?
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                          >
                                            <rect
                                              width="16"
                                              height="16"
                                              rx="8"
                                              transform="matrix(-1 0 0 1 20 4)"
                                              stroke="#1994EC"
                                              strokeWidth="2"
                                            />
                                            <path
                                              d="M15.5 10.1419L10.6622 14.25L8.5 12.0878"
                                              stroke="#1994EC"
                                              strokeWidth="2"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                          </svg> :
                                          null
                                        }
                                      </h3>
                                      {ele?.name === "Standard" ?
                                        <p>
                                          10 quotes per month
                                        </p>
                                        :
                                        <p>
                                          20 quotes per month
                                        </p>
                                      }
                                    </div>
                                  </div>
                                  <div>
                                    {userData?.activePlan?.name === ele?.name ?
                                      <button
                                        className="theme-white-comm-btn"
                                        onClick={() =>
                                          CancelSubScription()
                                        }
                                      >
                                        Manage
                                      </button> :
                                      <button
                                        className="theme-comm-btn"
                                        onClick={() =>
                                          handleSubscription(ele?.prices[0]?.id)
                                        }
                                      >
                                        Subscribe
                                      </button>
                                    }
                                  </div>
                                </div>
                                {ele?.name === "Standard" ?
                                  <ul>
                                    <li>. Get 10 quotes credited to your account every month.</li>
                                    <li>. Access to the SparkPro Mobile app</li>
                                    <li>. Cancel Anytime</li>

                                  </ul>
                                  :
                                  <ul>
                                    <li>. Get 20 quotes credited to your account every month</li>
                                    <li>. Access to the SparkPro Mobile app</li>
                                    <li>. Pro Member Badge on your profile</li>
                                    <li>. Top placement in search results</li>
                                    <li>. Cancel Anytime</li>
                                  </ul>
                                }

                              </div>
                            </div>
                          </div>
                        </Col>
                      ))}
                    </>
                  ) : (
                    <h1>No Data Found</h1>
                  )}
                </>}

            </Row>
          </div>
        </Container>
      </Layout>
    </>
  );
}
